import { render } from "./StaffGeneral.vue?vue&type=template&id=e56c27ae"
import script from "./StaffGeneral.vue?vue&type=script&lang=js"
export * from "./StaffGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__